import { render, staticRenderFns } from "./ViewTypeHandler.vue?vue&type=template&id=a23048a4"
import script from "./ViewTypeHandler.vue?vue&type=script&lang=ts"
export * from "./ViewTypeHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports